import {requestGet} from '@/utils/request';

const api = {
	GOLD_LIST: '/op/user_gold_list',
	SCORE_LIST: '/op/user_score_list',
}

export async function userGoldList(queryParams) {
    return requestGet(api.GOLD_LIST, queryParams);
}

export async function userScoreList(queryParams) {
    return requestGet(api.SCORE_LIST, queryParams);
}

